import { render, staticRenderFns } from "./proofOptions.vue?vue&type=template&id=29164b46&scoped=true&"
import script from "./proofOptions.vue?vue&type=script&lang=js&"
export * from "./proofOptions.vue?vue&type=script&lang=js&"
import style0 from "./proofOptions.vue?vue&type=style&index=0&id=29164b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29164b46",
  null
  
)

export default component.exports